<ion-icon [class]="size" [color]="color" src="assets/images/icons/{{icon}}.svg"></ion-icon>